import Modal from 'react-modal';
import { setMaskGeneric, getPermission, showMessageError } from '../../../classes/functions';
import { useState, useEffect} from 'react';
import api from '../../../config.js';
import './import.css';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import { FaCog } from 'react-icons/fa';
import ReactTooltip from "react-tooltip";
import InputDate from '../../../components/Inputs/Date/index.js';

export default function ImportData(){
  const [file, setFile] = useState('');
  const [warehouse, setWarehouse] = useState('');
  const [listWarehouse, setListWarehouse] = useState('');
  const [option, setOption] = useState('');
  const [filters, setFilters] = useState({
    data: ""
  });
  const [carrying, setCarrying] = useState(true);
  
  useEffect(()=> {
    async function loadImport(){
      setCarrying(false);
    }

    loadImport();
    getData();

    return () => {

    }
  }, []);

  function save() {
    setCarrying(true);
    
    const data_file = new FormData() 
    data_file.append('excel', file);
    
    if (option == '005') {
      api.post("/api/importData/post?option=" + option + "&warehouse=" + warehouse)
      .then((response) => {
        toast.success(`Custo médio importado.`);
        setCarrying(false);
      }).catch((error) => {
        console.log(error);
        showMessageError(error.response.data);
        setCarrying(false);
      });
    } else {
      api.post("/api/importData/post?option=" + option + "&data=" + filters.data, data_file)
      .then((response) => {
        toast.success(`Foram importados ${response.data.qtde} registros.`);
        setCarrying(false);
      }).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
    }
  }
  
  async function getData() {
    api.get("/api/warehouses/getList")
    .then((response) => {
      setListWarehouse(response.data);

    }).catch((error) => {
      showMessageError(error.response.data);
    });
  }

  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>
      <ReactTooltip />
      
      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <Title name="Importação de Dados">
        </Title>

        <div className="container">
          <div className="containerGroupData">
            <h2>Arquivo</h2>
            <hr></hr>
          
            <div className="divGroup">
              <div className="formDiv">
                <label>Selecione uma opção</label><br/>
                <select value={option} onChange={ (e) => setOption(e.target.value) } >
                  <option value="">Selecione</option>
                    <option value="001">Produtos</option>
                    <option value="002">Pessoas</option>
                    <option value="003">Endereços</option>
                    <option value="004">NF Protheus</option>
                    <option value="005">Custo Médio</option>
                    <option value="006">Saldos</option>
                </select>
              </div>
              {option == '005' && <div className="formDiv">
                <label>Selecione o armazém</label><br/>
                <select value={warehouse} onChange={ (e) => setWarehouse(e.target.value) } >
                  <option value="">Selecione</option>
                  {listWarehouse.map((item, index) => (
                    <option key={index} value={item.id}>{item.descricao}</option>
                  ))}
                </select>
              </div>}
              {['001','002','003','006'].indexOf(option) > -1 && <div className="formDiv">
                <label>Carregue um Arquivo</label><br/>
                <input 
                  type="file"
                  className="fileInput"
                  label="File"
                  name="file"
                  onChange={(e) =>
                  setFile(e.target.files[0])
                }/>
              </div>}
              {option == '004' && <div className="formDiv">
                <label>Data da Nota</label><br/>
                <InputDate filters={filters} setFilters={setFilters} propertyFilter="data" />
              </div>}
              <div className="formDiv">
                
              </div>
            </div>
          </div>
          <div className="formDiv">
            <button type="submit" className="buttonSubmit" onClick={save}>Importar</button>
          </div>
        </div>
      </div>}
    </div>
  )
}